module.exports = __webpack_public_path__ + "img/标题文字_主营业务.17a47a67.svg";